/**
 * Système de filtrage multiple pour collections Shopify
 * Version avec chargement complet de tous les produits (au-delà de 250)
 * Buzzzz Skateshop
 * 
 * CORRECTIONS :
 * - Format prix : 45,00 € au lieu de €45,00 (TOUS les produits)
 * - Images de rollover uniques (pas de clonage)
 * - Gestion complète des promos (badge + prix barrés)
 * - Suppression rollover si une seule image
 * - Préservation du lazy loading pour le hover
 * - Bouton de réinitialisation des filtres
 * - ✅ FIX : Tri rapide fonctionne maintenant sans recharger la page
 */

(function($) {
  'use strict';

  var MultiFilter = {
    allProducts: [],
    currentFilters: {
      brand: [],
      size: [],
      durability: [],
      other: []
    },
    collectionHandle: null,
    $productContainer: null,
    isLoading: false,

    handleize: function(str) {
      if (!str) return '';
      return str
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    },

    init: function() {
      if (!$('[data-section-type="collection-template"]').length) {
        return;
      }

      this.collectionHandle = this.getCollectionHandle();
      console.log('MultiFilter: Initialisation pour', this.collectionHandle);

      this.$productContainer = $('.collection-listing .product-list').first();
      if (!this.$productContainer.length) {
        console.error('MultiFilter: Conteneur de produits introuvable');
        return;
      }

      this.saveProductsFromDOM();
      this.showLoadingIndicator();
      this.loadProductTags();
      this.convertFiltersToMultiSelect();
      this.parseUrlFilters();
      this.bindFilterEvents();
      this.addResetButton();
      
      var self = this;
      setTimeout(function() {
        self.bindSortEvents();
      }, 100);
    },

    getCollectionHandle: function() {
      var path = window.location.pathname;
      var match = path.match(/\/collections\/([^\/]+)/);
      return match ? match[1] : null;
    },

    saveProductsFromDOM: function() {
      var self = this;
      
      this.$productContainer.find('.product-block').each(function() {
        var $product = $(this);
        var productId = $product.attr('data-product-id');
        
        self.fixPriceFormat($product);
        
        self.allProducts.push({
          element: $product,
          id: productId,
          tags: [],
          tagsHandleized: [],
          createdAt: null  // Ajout pour le tri par date
        });
      });

      console.log('MultiFilter:', this.allProducts.length, 'produits trouvés dans le DOM');
    },

    fixPriceFormat: function($product) {
      $product.find('.theme-money').each(function() {
        var $priceEl = $(this);
        var priceText = $priceEl.text().trim();
        
        var match = priceText.match(/€\s*(\d+[,\.]\d{2})/);
        if (match) {
          var price = match[1];
          $priceEl.text(price + ' €');
        }
      });
    },

    showLoadingIndicator: function() {
      if (!this.$productContainer.find('.loading-products').length) {
        this.$productContainer.append(
          '<div class="loading-products" style="grid-column: 1/-1; text-align: center; padding: 20px; font-size: 14px; color: #666;">' +
          '<div style="display: inline-block; width: 20px; height: 20px; border: 2px solid #f3f3f3; border-top: 2px solid #333; border-radius: 50%; animation: spin 1s linear infinite; margin-right: 10px;"></div>' +
          'Chargement de tous les produits...' +
          '</div>'
        );
        
        if (!$('#loading-spinner-style').length) {
          $('<style id="loading-spinner-style">@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }</style>').appendTo('head');
        }
      }
    },

    hideLoadingIndicator: function() {
      this.$productContainer.find('.loading-products').remove();
    },

    loadProductTags: function() {
      var self = this;
      var allProductsFromAPI = [];
      var page = 1;
      var limit = 250;

      function loadPage() {
        var url = '/collections/' + self.collectionHandle + '/products.json?limit=' + limit + '&page=' + page;
        
        console.log('MultiFilter: Chargement page', page);
        
        $.ajax({
          url: url,
          dataType: 'json',
          success: function(data) {
            if (data.products && data.products.length > 0) {
              console.log('MultiFilter: Page', page, '-', data.products.length, 'produits reçus');
              allProductsFromAPI = allProductsFromAPI.concat(data.products);
              
              if (data.products.length === limit) {
                page++;
                loadPage();
              } else {
                finishLoading(allProductsFromAPI);
              }
            } else {
              finishLoading(allProductsFromAPI);
            }
          },
          error: function(xhr, status, error) {
            console.error('MultiFilter: Erreur chargement page', page, ':', error);
            finishLoading(allProductsFromAPI);
          }
        });
      }

      function finishLoading(productsFromAPI) {
        console.log('MultiFilter: TOTAL', productsFromAPI.length, 'produits chargés depuis API');
        self.hideLoadingIndicator();
        
        var productMap = {};
        productsFromAPI.forEach(function(p) {
          productMap[p.id.toString()] = p;
        });
        
        self.allProducts.forEach(function(product) {
          var apiProduct = productMap[product.id];
          
          if (apiProduct && apiProduct.tags) {
            product.tags = apiProduct.tags;
            product.tagsHandleized = apiProduct.tags.map(function(tag) {
              return self.handleize(tag);
            });
            product.createdAt = apiProduct.created_at;  // Stocker la date de création
          }
        });

        productsFromAPI.forEach(function(apiProduct) {
          var existsInDOM = self.allProducts.some(function(p) {
            return p.id === apiProduct.id.toString();
          });
          
          if (!existsInDOM) {
            var $newProduct = self.createProductElement(apiProduct);
            
            self.allProducts.push({
              element: $newProduct,
              id: apiProduct.id.toString(),
              tags: apiProduct.tags,
              tagsHandleized: apiProduct.tags.map(function(tag) {
                return self.handleize(tag);
              }),
              createdAt: apiProduct.created_at  // Stocker la date de création
            });
          }
        });

        console.log('MultiFilter: Total après ajout produits API:', self.allProducts.length, 'produits');
        
        if (self.hasActiveFilters()) {
          self.applyFilters();
        } else {
          self.displayProducts(self.allProducts);
        }
        
        self.updateResetButtonVisibility();
      }

      loadPage();
    },

    createProductElement: function(product) {
      var $firstProduct = this.$productContainer.find('.product-block').first();
      
      var $clone = $firstProduct.clone(true, true);
      
      $clone.attr('data-product-id', product.id);
      
      $clone.find('.product-block__title').text(product.title);
      
      if (product.images && product.images.length > 0) {
        var imgUrl = product.images[0].src;
        var srcset = this.generateSrcset(imgUrl);
        
        var $primaryImageContainer = $clone.find('.primary-image');
        var $mainImg = $primaryImageContainer.find('.rimage__image');
        
        if ($mainImg.length) {
          $mainImg.attr({
            'data-srcset': srcset,
            'srcset': srcset,
            'alt': product.title
          }).removeClass('lazyloaded lazyload')
            .addClass('lazyload');
        }
        
        var $imageLabel = $clone.find('.image-label-wrap');
        var $rolloverContainer = $clone.find('.secondary-image');
        
        $rolloverContainer.remove();
        
        if (product.images.length > 1) {
          var imgUrlRollover = product.images[1].src;
          var bgset = this.generateBgset(imgUrlRollover);
          var bgUrl = this.getImageUrl(imgUrlRollover, '540x');
          
          var secondaryImageHtml = 
            '<div class="secondary-image lazyload rimage-background" ' +
            'data-bgset="' + bgset + '" ' +
            'data-sizes="auto" ' +
            'data-parent-fit="contain" ' +
            'style="background-image: url(' + bgUrl + ');"></div>';
          
          $imageLabel.find('.primary-image').after(secondaryImageHtml);
          
          $clone.find('.image-cont').addClass('with-secondary-image same-aspect-ratio');
        } else {
          $clone.find('.image-cont').removeClass('with-secondary-image');
        }
      }
      
      if (product.variants && product.variants.length > 0) {
        var variant = product.variants[0];
        var priceRaw = variant.price;
        var priceInEuros = parseFloat(priceRaw);
        var priceFormatted = priceInEuros.toFixed(2).replace('.', ',') + ' €';
        
        var $priceSpan = $clone.find('.price .theme-money');
        
        if (variant.compare_at_price) {
          var comparePriceRaw = variant.compare_at_price;
          var comparePriceInEuros = parseFloat(comparePriceRaw);
          
          if (comparePriceInEuros > priceInEuros) {
            $priceSpan.addClass('on-sale').text(priceFormatted);
            
            var comparePriceFormatted = comparePriceInEuros.toFixed(2).replace('.', ',') + ' €';
            var $reducedfrom = $clone.find('.reducedfrom');
            
            if ($reducedfrom.length === 0) {
              $clone.find('.price').parent().append(
                '<div class="reducedfrom"><span class="amount theme-money">' + comparePriceFormatted + '</span></div>'
              );
            } else {
              $reducedfrom.find('.theme-money').text(comparePriceFormatted);
            }
            
            var $imageLabel = $clone.find('.image-label-wrap');
            if ($imageLabel.length && !$imageLabel.find('.productlabel.sale').length) {
              $imageLabel.append('<span class="productlabel sale"><span>Offre</span></span>');
            }
          } else {
            $priceSpan.removeClass('on-sale').text(priceFormatted);
            $clone.find('.reducedfrom').remove();
            $clone.find('.productlabel.sale').remove();
          }
        } else {
          $priceSpan.removeClass('on-sale').text(priceFormatted);
          $clone.find('.reducedfrom').remove();
          $clone.find('.productlabel.sale').remove();
        }
      }
      
      $clone.find('a').attr('href', '/products/' + product.handle);
      
      $clone.find('[data-handle]').attr('data-handle', product.handle);
      
      $clone.hide();
      
      return $clone;
    },

    getImageUrl: function(url, size) {
      if (!url) return '';
      
      var filename = url.split('/').pop().split('?')[0];
      var version = url.includes('?v=') ? url.split('?v=')[1] : '';
      var baseUrl = url.substring(0, url.lastIndexOf('/') + 1);
      var nameWithoutExt = filename.substring(0, filename.lastIndexOf('.'));
      var ext = filename.substring(filename.lastIndexOf('.'));
      
      var newUrl = baseUrl + nameWithoutExt + (size ? '_' + size : '') + ext;
      if (version) {
        newUrl += '?v=' + version;
      }
      
      return '//' + newUrl.replace(/^https?:\/\//, '');
    },

    generateSrcset: function(url) {
      var sizes = ['180', '220', '300', '360', '460', '540', '720', '900', '1080', '1296', '1512', '1728', '2048'];
      var srcset = [];
      
      for (var i = 0; i < sizes.length; i++) {
        var size = sizes[i];
        srcset.push(this.getImageUrl(url, size + 'x') + ' ' + size + 'w');
      }
      
      return srcset.join(', ');
    },

    generateBgset: function(url) {
      var sizes = [
        {size: '180', dim: '180w 180h'},
        {size: '360', dim: '360w 360h'},
        {size: '540', dim: '540w 540h'},
        {size: '720', dim: '720w 720h'},
        {size: '900', dim: '900w 900h'},
        {size: '1024', dim: '1024w 1024h'}
      ];
      
      var bgset = [];
      
      for (var i = 0; i < sizes.length; i++) {
        if (sizes[i].size === '1024') {
          bgset.push(this.getImageUrl(url, '') + ' ' + sizes[i].dim);
        } else {
          bgset.push(this.getImageUrl(url, sizes[i].size + 'x') + ' ' + sizes[i].dim);
        }
      }
      
      return bgset.join(',\n  ');
    },

    convertFiltersToMultiSelect: function() {
      var self = this;

      $('.multi-tag-row .tags.navigation').each(function() {
        var $filterGroup = $(this);
        var category = self.determineFilterCategory($filterGroup);
        
        $filterGroup.find('.navigation__item').each(function() {
          var $item = $(this);
          var $link = $item.find('.navigation__link');
          var tagHandleized = $item.attr('data-tag');
          
          if (!tagHandleized) return;

          $link.attr('data-tag', tagHandleized);
          $link.attr('data-category', category);
          $item.attr('data-category', category);
        });
      });

      console.log('MultiFilter: Filtres convertis');
    },

    determineFilterCategory: function($filterGroup) {
      if ($filterGroup.hasClass('cat-custom-1')) return 'brand';
      if ($filterGroup.hasClass('cat-custom-2')) return 'size';
      if ($filterGroup.hasClass('cat-custom-3')) return 'durability';
      return 'other';
    },

    parseUrlFilters: function() {
      var path = window.location.pathname;
      var match = path.match(/\/collections\/([^\/]+)(?:\/(.+?))?(?:\?|$)/);
      
      if (!match) {
        this.parseSortFromUrl();
        return;
      }
      
      var collectionHandle = match[1];
      var tagsInUrl = match[2];
      
      if (tagsInUrl && window.location.pathname !== '/collections/' + collectionHandle) {
        console.log('MultiFilter: Tags détectés dans URL, redirection vers collection de base...');
        
        sessionStorage.setItem('multifilter_pending_tags', tagsInUrl);
        var sortBy = new URLSearchParams(window.location.search).get('sort_by');
        if (sortBy) {
          sessionStorage.setItem('multifilter_pending_sort', sortBy);
        }
        
        window.location.href = '/collections/' + collectionHandle;
        return;
      }
      
      var pendingTags = sessionStorage.getItem('multifilter_pending_tags');
      var pendingSort = sessionStorage.getItem('multifilter_pending_sort');
      
      if (pendingTags) {
        console.log('MultiFilter: Restauration des filtres depuis sessionStorage:', pendingTags);
        sessionStorage.removeItem('multifilter_pending_tags');
        if (pendingSort) {
          sessionStorage.removeItem('multifilter_pending_sort');
        }
        
        var tags = pendingTags.split('+');
        var self = this;
        
        this.currentFilters = { brand: [], size: [], durability: [], other: [] };
        
        tags.forEach(function(tag) {
          var $item = $('.navigation__item[data-tag="' + tag + '"]').first();
          
          if ($item.length) {
            var category = $item.attr('data-category');
            
            if (category && !self.currentFilters[category].includes(tag)) {
              self.currentFilters[category].push(tag);
              $item.addClass('active');
              
              var $link = $item.find('.navigation__link');
              if (!$link.find('.x').length) {
                $link.append(' <span class="x">×</span>');
              }
            }
          }
        });
        
        if (pendingSort) {
          $('#sort-by').val(pendingSort).trigger('chosen:updated');
        }

        console.log('MultiFilter: Filtres restaurés', this.currentFilters);
        this.parseSortFromUrl();
        
        this.updateUrl();
        return;
      }
      
      this.parseSortFromUrl();
    },

    parseSortFromUrl: function() {
      var urlParams = new URLSearchParams(window.location.search);
      var sortBy = urlParams.get('sort_by');
      
      if (sortBy) {
        $('#sort-by').val(sortBy);
      }
    },

    hasActiveFilters: function() {
      return this.currentFilters.brand.length > 0 ||
             this.currentFilters.size.length > 0 ||
             this.currentFilters.durability.length > 0 ||
             this.currentFilters.other.length > 0;
    },

    addResetButton: function() {
      var self = this;
      
      if ($('#reset-filters-btn').length) {
        return;
      }
      
      var $resetButton = $('<a href="#" id="reset-filters-btn" class="tags reset-filters" style="display: none;">' +
        'Réinitialiser les filtres <span class="x">×</span>' +
        '</a>');
      
      var $filters = $('.filters');
      var $sortElement = $filters.find('.sort.tags');
      
      if ($sortElement.length) {
        $resetButton.insertBefore($sortElement);
      } else {
        $filters.append($resetButton);
      }
      
      if (!$('#reset-filters-style').length) {
        $('<style id="reset-filters-style">' +
          '#reset-filters-btn { cursor: pointer; color: #333; transition: opacity 0.2s; }' +
          '#reset-filters-btn:hover { opacity: 0.7; }' +
          '#reset-filters-btn .x { font-weight: bold; margin-left: 5px; }' +
          '</style>').appendTo('head');
      }
      
      $resetButton.on('click', function(e) {
        e.preventDefault();
        self.resetAllFilters();
      });
      
      console.log('MultiFilter: Bouton de réinitialisation ajouté');
    },

    updateResetButtonVisibility: function() {
      var $resetButton = $('#reset-filters-btn');
      
      if (this.hasActiveFilters()) {
        $resetButton.fadeIn(200);
      } else {
        $resetButton.fadeOut(200);
      }
    },

    resetAllFilters: function() {
      console.log('MultiFilter: Réinitialisation de tous les filtres');
      
      $('.multi-tag-row .navigation__item.active').each(function() {
        $(this).removeClass('active');
        $(this).find('.x').remove();
      });
      
      this.currentFilters = {
        brand: [],
        size: [],
        durability: [],
        other: []
      };
      
      this.applyFilters();
      
      this.updateUrl();
      
      this.updateResetButtonVisibility();
      
      console.log('MultiFilter: Filtres réinitialisés - Affichage de tous les produits');
    },

    bindFilterEvents: function() {
      var self = this;

      $(document).on('click', '.multi-tag-row .navigation__link', function(e) {
        e.preventDefault();
        
        var $link = $(this);
        var $item = $link.closest('.navigation__item');
        var tag = $item.attr('data-tag');
        var category = $item.attr('data-category');
        
        if (!tag || !category) return;
        
        var isActive = $item.hasClass('active');

        if (isActive) {
          $item.removeClass('active');
          var index = self.currentFilters[category].indexOf(tag);
          if (index > -1) {
            self.currentFilters[category].splice(index, 1);
          }
          $link.find('.x').remove();
        } else {
          $item.addClass('active');
          if (!self.currentFilters[category].includes(tag)) {
            self.currentFilters[category].push(tag);
          }
          if (!$link.find('.x').length) {
            $link.append(' <span class="x">×</span>');
          }
        }

        console.log('MultiFilter: Filtres actifs', self.currentFilters);

        self.applyFilters();
        self.updateUrl();
        self.updateResetButtonVisibility();
      });
    },

    bindSortEvents: function() {
      var self = this;
      
      $('#sort-by').off('change');
      
      $('#sort-by').on('change', function() {
        var newSort = $(this).val();
        console.log('MultiFilter: Tri changé vers', newSort);
        
        // ✅ CORRECTION : Seul "best-selling" nécessite un rechargement de page
        if (newSort === 'best-selling') {
          console.log('MultiFilter: Tri "Meilleurs vendeurs" nécessite un rechargement de page');
          var queryParams = self.getQueryParams();
          queryParams.sort_by = newSort;
          location.search = $.param(queryParams);
        } else {
          // Tous les autres tris fonctionnent en JavaScript
          self.applyFilters();
          self.updateUrl();
        }
      });
    },
    
    getQueryParams: function() {
      var params = {};
      var search = window.location.search.substring(1);
      if (search) {
        var pairs = search.split('&');
        for (var i = 0; i < pairs.length; i++) {
          var pair = pairs[i].split('=');
          params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
        }
      }
      return params;
    },

    applyFilters: function() {
      var self = this;
      var hasFilters = this.hasActiveFilters();

      var filteredProducts = this.allProducts.filter(function(product) {
        if (!hasFilters) return true;
        if (!product.tagsHandleized || product.tagsHandleized.length === 0) return false;

        var matchBrand = self.currentFilters.brand.length === 0 || 
                        self.currentFilters.brand.some(function(filterTag) {
                          return product.tagsHandleized.includes(filterTag);
                        });

        var matchSize = self.currentFilters.size.length === 0 || 
                       self.currentFilters.size.some(function(filterTag) {
                         return product.tagsHandleized.includes(filterTag);
                       });

        var matchDurability = self.currentFilters.durability.length === 0 || 
                             self.currentFilters.durability.some(function(filterTag) {
                               return product.tagsHandleized.includes(filterTag);
                             });

        var matchOther = self.currentFilters.other.length === 0 || 
                        self.currentFilters.other.some(function(filterTag) {
                          return product.tagsHandleized.includes(filterTag);
                        });

        return matchBrand && matchSize && matchDurability && matchOther;
      });

      console.log('MultiFilter:', filteredProducts.length, '/', this.allProducts.length, 'produits correspondent');

      var sortBy = $('#sort-by').val();
      if (sortBy && sortBy !== 'manual') {
        filteredProducts = this.sortProducts(filteredProducts, sortBy);
      }

      this.displayProducts(filteredProducts);
      
      this.updateSortSelectDisplay();
    },
    
    updateSortSelectDisplay: function() {
      var currentSort = $('#sort-by').val();
      
      if (typeof $.fn.select2 !== 'undefined' && $('#sort-by').hasClass('select2-hidden-accessible')) {
        var $select = $('#sort-by');
        var selectedText = $select.find('option[value="' + currentSort + '"]').text();
        
        $('#select2-sort-by-container').text(selectedText).attr('title', selectedText);
      }
    },

    sortProducts: function(products, sortBy) {
      var sorted = products.slice();
      
      switch(sortBy) {
        case 'price-ascending':
          sorted.sort(function(a, b) {
            var priceA = parseFloat(a.element.find('.price .theme-money').first().text().replace(/[^0-9,]/g, '').replace(',', '.')) || 0;
            var priceB = parseFloat(b.element.find('.price .theme-money').first().text().replace(/[^0-9,]/g, '').replace(',', '.')) || 0;
            return priceA - priceB;
          });
          break;
          
        case 'price-descending':
          sorted.sort(function(a, b) {
            var priceA = parseFloat(a.element.find('.price .theme-money').first().text().replace(/[^0-9,]/g, '').replace(',', '.')) || 0;
            var priceB = parseFloat(b.element.find('.price .theme-money').first().text().replace(/[^0-9,]/g, '').replace(',', '.')) || 0;
            return priceB - priceA;
          });
          break;
          
        case 'title-ascending':
          sorted.sort(function(a, b) {
            var titleA = a.element.find('.product-block__title').text().trim();
            var titleB = b.element.find('.product-block__title').text().trim();
            return titleA.localeCompare(titleB, 'fr');
          });
          break;
          
        case 'title-descending':
          sorted.sort(function(a, b) {
            var titleA = a.element.find('.product-block__title').text().trim();
            var titleB = b.element.find('.product-block__title').text().trim();
            return titleB.localeCompare(titleA, 'fr');
          });
          break;
          
        case 'created-ascending':
          // Date: ancien à récent
          sorted.sort(function(a, b) {
            var dateA = a.createdAt ? new Date(a.createdAt).getTime() : 0;
            var dateB = b.createdAt ? new Date(b.createdAt).getTime() : 0;
            return dateA - dateB;
          });
          break;
          
        case 'created-descending':
          // Date: récent à ancien
          sorted.sort(function(a, b) {
            var dateA = a.createdAt ? new Date(a.createdAt).getTime() : 0;
            var dateB = b.createdAt ? new Date(b.createdAt).getTime() : 0;
            return dateB - dateA;
          });
          break;
      }
      
      return sorted;
    },

    displayProducts: function(products) {
      var self = this;
      
      this.allProducts.forEach(function(product) {
        product.element.hide();
      });

      if (products.length === 0) {
        if (!this.$productContainer.find('.no-products-message').length) {
          this.$productContainer.append(
            '<div class="no-products-message" style="grid-column: 1/-1; text-align: center; padding: 40px;">' +
            '<h5>Aucun produit ne correspond à votre recherche</h5>' +
            '</div>'
          );
        }
        this.updateProductCount(0);
      } else {
        this.$productContainer.find('.no-products-message').remove();
        
        products.forEach(function(product) {
          product.element.show();
          self.$productContainer.append(product.element);
        });
        
        this.updateProductCount(products.length);
      }

      $('.pagination-row').hide();

      if (typeof window.lazySizes !== 'undefined') {
        setTimeout(function() {
          window.lazySizes.autoSizer.checkElems();
        }, 100);
      }
    },

    updateProductCount: function(count) {
      var $header = $('.page-header');
      var $counter = $header.find('.product-count');
      
      if ($counter.length === 0) {
        $counter = $('<div class="product-count" style="margin-top: 10px; font-size: 14px; color: #666;"></div>');
        $header.append($counter);
      }
      
      $counter.text(count + ' produit' + (count > 1 ? 's' : ''));
    },

    updateUrl: function() {
      var allTags = [].concat(
        this.currentFilters.brand,
        this.currentFilters.size,
        this.currentFilters.durability,
        this.currentFilters.other
      );

      var newUrl = '/collections/' + this.collectionHandle;
      var sortBy = $('#sort-by').val();
      var queryString = '';
      
      if (sortBy && sortBy !== 'manual') {
        queryString = '?sort_by=' + sortBy;
      }
      
      if (allTags.length > 0) {
        newUrl += '/' + allTags.join('+');
      }
      
      newUrl += queryString;

      if (window.history && window.history.pushState) {
        window.history.pushState({path: newUrl}, '', newUrl);
      }
    }
  };

  $(document).ready(function() {
    var attempts = 0;
    var maxAttempts = 100;
    
    var checkProducts = setInterval(function() {
      attempts++;
      var productCount = $('.collection-listing .product-list .product-block').length;
      
      console.log('MultiFilter: Tentative', attempts, '- Produits trouvés:', productCount);
      
      if (productCount > 0 || attempts >= maxAttempts) {
        clearInterval(checkProducts);
        
        if (productCount > 0) {
          console.log('MultiFilter: Démarrage avec', productCount, 'produits');
          MultiFilter.init();
        } else {
          console.error('MultiFilter: Aucun produit trouvé après', maxAttempts, 'tentatives');
          console.error('MultiFilter: Vérifier si le conteneur .collection-listing .product-list existe');
        }
      }
    }, 200);
  });

  window.MultiFilter = MultiFilter;

})(jQuery);